import { render, staticRenderFns } from "./NFSESetting.vue?vue&type=template&id=28f18f6a&scoped=true&"
import script from "./NFSESetting.vue?vue&type=script&lang=js&"
export * from "./NFSESetting.vue?vue&type=script&lang=js&"
import style0 from "./NFSESetting.vue?vue&type=style&index=0&id=28f18f6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f18f6a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VSelect,VSwitch,VTextField})
